import apiService from './api';

const consultationVaccinationService = {
  list(consultationId) {
    return apiService.get(`/consultations/${consultationId}/vaccinations`);
  },

  add(consultationId, payload) {
    return apiService.post(`/consultations/${consultationId}/vaccinations`, payload);
  },

  update(consultationId, vaccinationId, payload) {
    return apiService.put(
      `/consultations/${consultationId}/vaccinations/${vaccinationId}`,
      payload
    );
  },

  remove(consultationId, vaccinationId) {
    return apiService.delete(
      `/consultations/${consultationId}/vaccinations/${vaccinationId}`
    );
  }
};

export default consultationVaccinationService;
